var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEditBoxLine = function SvgEditBoxLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m10.854 2.6-1.2 1.2H3.8v8.4h8.4V6.346l1.2-1.2V12.8a.6.6 0 0 1-.6.6H3.2a.6.6 0 0 1-.6-.6V3.2a.6.6 0 0 1 .6-.6zm2.237-.54.849.85-5.515 5.515-.847.002-.002-.85z"
  })));
};
export default SvgEditBoxLine;